import { EventEmitter, Injectable }  from '@angular/core';

export class LoadProcess {
	private name = "DEFAULT"
	constructor(name?: string) {
		if (name) this.name = name;
	}
}

@Injectable()
export class LoaderService {
	public processAdded: EventEmitter<LoadProcess> = new EventEmitter<LoadProcess>();
	public processRemoved: EventEmitter<LoadProcess> = new EventEmitter<LoadProcess>();

	constructor() { }

	public addProcess(process: LoadProcess): void {
		console.log("add loading: ", process)
		this.processAdded.emit(process);
	}

	public removeProcess(process: LoadProcess): void {
		console.log("remove loading: ", process)
		this.processRemoved.emit(process);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/loader.service.ts